const CustomizationSection = () => {
  const items = [
    {
      title: "Targeting",
      desc: "Your ideal client, defined and pursued"
    },
    {
      title: "Messaging",
      desc: "Your voice, your tone, your standards"
    },
    {
      title: "Volume",
      desc: "Scaled to what you can actually handle"
    },
    {
      title: "Compliance",
      desc: "Built in from day one, not bolted on"
    }
  ];

  return (
    <section
      id="customization"
      data-testid="customization-section"
      className="py-20 md:py-32 px-5 md:px-12 lg:px-20 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 mb-12 md:mb-16">
          <div>
            <p className="text-[#6DBE2E] text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase mb-4 md:mb-6">
              Your Program
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-white leading-tight tracking-tight">
              Built around you. Not around us.
            </h2>
          </div>

          <div className="lg:pt-4">
            <p className="text-white/50 text-base md:text-lg leading-relaxed">
              No off-the-shelf packages. Every engagement starts from scratch 
              based on who you are, who you want, and how you work.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((item, i) => (
            <div key={i} className="p-4 md:p-6 border border-white/5 bg-black/50">
              <h4 className="text-white text-sm md:text-base font-medium mb-2">{item.title}</h4>
              <p className="text-white/40 text-xs md:text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomizationSection;
